// Hand-drawn / sketchy SVG marks — intentionally imperfect/asymmetric
// Used for active nav indicator and hero emphasis

export function HandDrawnUnderline({ className = "", color = "#FF3B30" }) {
  return (
    <svg
      className={`pointer-events-none absolute inset-x-0 -bottom-1.5 h-2 ${className}`}
      viewBox="0 0 100 8"
      preserveAspectRatio="none"
      aria-hidden
    >
      <path
        d="M 1 5 Q 12 2, 25 4 T 50 5 Q 65 2, 80 4 T 99 3"
        stroke={color}
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}

export function HandDrawnCorner({ className = "", color = "#FF3B30" }) {
  return (
    <svg
      className={`pointer-events-none absolute -top-1.5 -right-2 w-3.5 h-3.5 rotate-[8deg] ${className}`}
      viewBox="0 0 14 14"
      fill="none"
      aria-hidden
    >
      <path d="M 3 11 L 11 3" stroke={color} strokeWidth="1.7" strokeLinecap="round" />
      <path d="M 7 2.5 L 11.5 2.5 L 11.5 7" stroke={color} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/**
 * Wrap any inline text with this to get an asymmetric hand-drawn highlight:
 * bottom-left squiggly underline + top-right small corner tick.
 */
export default function HandDrawnMark({ children, className = "", as: Tag = "span" }) {
  return (
    <Tag className={`relative inline-block ${className}`}>
      {children}
      <HandDrawnUnderline />
      <HandDrawnCorner />
    </Tag>
  );
}
